import React from 'react';

import { GridCard } from 'redpoints-front-components/index';

import GridCardFooter from './GridCardFooter';

const GridWithCard = ({ data = [], handleCheckBox, handleModal, loading }) => (
  <div>
    <div className="grid-container">
      {data.map((item, i) => (
        <div key={`grid-item-${item.imageId}-${i}`} className="grid-item">
          <GridCard imgUrl={item.src} actionImg={() => handleModal(true, item)}>
            <GridCardFooter item={item} handleCheckBox={handleCheckBox} />
          </GridCard>
        </div>
      ))}
    </div>
    <div className="loader-container">{loading}</div>
  </div>
);

export default GridWithCard;
